export default __webpack_public_path__ + "static/media/door.3dfb214c.svg";